import { useEffect } from "react";
import { EditPieceStepProps } from "../dashboardEditPiece";
import EditPieceContributorElement from "./components/editPieceContributorElement";
import EditPieceStepAddButton from "./components/editPieceStepAddButton";

import contributorTypes from "../../../../data/json/contributorTypes.json";
import { ContributorDTO, PieceDTO } from "../../../../openapi-generated-client";

export default function EditPieceContributors(props: EditPieceStepProps) {

    function getMessage(data: PieceDTO) {
        for(var i = 0; i < data.contributors.length; i++) {
            var current = data.contributors[i].name;
            if(current == undefined ||current == "" || current.length < 3) {
                return "Every contributor must contain at least 3 letters";
            }
        }
        return "";
    }
    
    useEffect(() => {
        props.setStepMessage(getMessage(props.piece));
    }, [props.piece])

    return <>
            <h2>Contributors</h2>
            <p className="quotation">Add contributors. Performers, arrangers, text writers, ...</p>
            <div className="element-list">
                {props.piece.contributors.map((e, i) => {
                    return <EditPieceContributorElement onDelete={() => {
                        const newContributors = [...props.piece.contributors];
                        newContributors.splice(i, 1);
                        props.setPiece({...props.piece, contributors: newContributors});
                    }} contributor={e} setContributor={(v: ContributorDTO) => {
                        const newContributors = [...props.piece.contributors];
                        newContributors[i] = v;
                        props.setPiece({...props.piece, contributors: newContributors});
                    }}/>;
                })}
            </div>
            <EditPieceStepAddButton onClick={() => {
                const newData = {...props.piece, contributors: [...props.piece.contributors, {
                    type: contributorTypes[2], name: "", artistId: -1
                }]};
                props.setPiece(newData);
            }}>
                Click to add contributor
            </EditPieceStepAddButton>
        </>;

}